import React, { useEffect } from "react";
import PrintInvoiceModal from "./Modal/PrintInvoiceModal";
import FileModal from "./Modal/FileModal";
import {
  formatCurrency,
  getAlert,
  getData,
  getDataWithComp,
  parseCurrency,
} from "../../utils/SamuiUtils";

import Datetime from "react-datetime";
import moment from "moment";

const Breadcrumbs = ({
  page,
  isShowStatus,
  statusName,
  statusColour,
  otherStatusName,
  otherStatusColour,
  otherTypeName,
  otherTypeColour,
  docStatusForClosePK,
  items,
  docIsINV,
  onHandleClick,
  onHandlePayslip,
  onHandleCloseForWarehouse,
  onHandleCloseForAccount,
  onHandleInvoice1,
  onHandleInvoice2,
  onHandleInvoice3,
  urlImg,
  handleUploadSlip,
  base64Image,
  setBase64Image,
  handleUpdateSlip,
  docInvNo,
  isVatChecked,

  // รับ Parmeter แนบเอกสารจ้า
  mode,
  openUploadAttach,
  setOpenUploadAttach,
  showViewAttachModal,
  setShowViewAttachModal,
  selectedFiles,
  selectedRecFiles,
  setSelectedFiles,
  handleRemoveImage,
  handleInputFileChange,
  handleBeforeUploadAttach,
}) => {
  const [showOptionInvModal, setShowOptionInvModal] = React.useState(false);
  const [showSlipModal, setShowSlipModal] = React.useState(false);

  // แสดงยอดเงินด้วย
  const [totalPrice, setTotalPrice] = React.useState(0);
  const [paymentHistory, setPaymentHistory] = React.useState([]);

  const [showChequeModal, setShowChequeModal] = React.useState(false);
  const [chequeNo, setChequeNo] = React.useState("");
  const [chequeName, setChequeName] = React.useState("");
  const [chequeBranch, setChequeBranch] = React.useState("");

  useEffect(() => {
    const getPayHistoryData = async () => {
      try {
        // ดึงยอดเต็ม กรณีที่ไม่ใช่จ่ายหลายช่องทาง
        const response = await getDataWithComp(
          window.location.pathname === "/billofsale"
            ? "API_0701_SO_H"
            : "API_1301_BL_H",
          `AND Doc_No = '${page}'`
        );

        if (response && response.length > 0) {
          setTotalPrice(response[0].Pay_Total);

          // ดึงประวัติการชําระเงิน
          const paymentHistoryResponse = await getData(
            "Pay_History",
            `
              DocCode_Id = ${
                window.location.pathname === "/billofsale" ? 7 : 14
              } 
              AND Doc_Id = ${
                window.location.pathname === "/billofsale"
                  ? response[0].Doc_ID
                  : response[0].Doc_Id
              }
            `
          );
          if (paymentHistoryResponse && paymentHistoryResponse.length > 0) {
            setPaymentHistory(paymentHistoryResponse);

            for (const payment of paymentHistoryResponse) {
              if (payment.Pay_Type === 3) {
                setChequeNo(payment.Pay_Cheque_No);
                setChequeName(payment.Pay_Cheque_Branch);
                setChequeBranch(
                  moment(payment.Pay_Cheque_date)
                    .add(543, "years")
                    .format("DD/MM/YYYY")
                );
              }
            }
          }
        }
      } catch (error) {
        getAlert("FAILED", "พบข้อผิดพลาด ในการดึงข้อมูลใบขาย");
      }
    };
    if (
      window.location.pathname === "/billofsale" ||
      window.location.pathname === "/bill"
    ) {
      getPayHistoryData();
    }
  }, [otherTypeName]);

  const isHiddenPath = () => {
    const hiddenPaths = [
      "/initialdata",
      "/creditor",
      "/debtor",
      "/employee",
      "/tbsetitem",
      "/APtype",
      "/ARtype",
      "/company",
      "/dept",
      "/position",
      "/car",
      "/transType",
      "/docType",
      "/brand",
      "/tb-set-unit",
      "/tb-set-wh",
    ];
    return hiddenPaths.includes(window.location.pathname);
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    // อัปเดตค่าใน formMasterList
    setChequeBranch(newValue);
  };

  return (
    <>
      <div
        className="page-header"
        style={{
          position: "fixed", // เปลี่ยนจาก relative เป็น fixed
          top: "0",
          left: "0",
          width: "100vw", // ขยายความกว้างให้เต็มหน้าจอ
          backgroundColor: "#f8f9fa",
          zIndex: "1000",
          padding: "15px 0",
          paddingLeft: "3%",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
          alignItems: "baseline",
        }}
      >
        <p style={{ color: "#EF6C00" }}>
          {process.env.REACT_APP_ENV_Type}{" "}
          {window.localStorage.getItem("name")
            ? window.localStorage.getItem("name")
            : ""}
        </p>
        <h1
          className="fw-bold"
          style={{ color: "#2A2F5B", paddingLeft: "1rem" }}
        >
          {page}
        </h1>
        <ul className="breadcrumbs">
          <li className="nav-home">
            <a href="/">
              <i className="icon-home fw-bold" style={{ color: "#EF6C00" }}></i>
            </a>
          </li>
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <li className="separator fw-bold" style={{ color: "#EF6C00" }}>
                <i className="icon-arrow-right fw-bold"></i>
              </li>
              <li className="nav-item">
                <a
                  className="fw-bold"
                  style={item.style || { color: "#EF6C00" }}
                  href={item.url}
                >
                  {item.name}
                </a>
              </li>
            </React.Fragment>
          ))}
        </ul>
        {isShowStatus && (
          <div style={{ display: "flex", marginLeft: "10px" }}>
            <div
              className="page-header col-12"
              style={{ marginBottom: "-1px" }}
            >
              <button
                className="btn btn-md w-100"
                style={{
                  backgroundColor: statusColour,
                  fontSize: "16px",
                  color: "white",
                  pointerEvents: "none",
                  userSelect: "none",
                }}
              >
                {statusName}
              </button>
            </div>
          </div>
        )}

        {/* ใช้สำหรับใบรับสินค้า แสดงสถานะจ่าย && แสดงสถานะการจัดส่งของ Picking List */}
        {otherStatusName && otherStatusColour && (
          <div style={{ display: "flex", marginLeft: "10px" }}>
            <div
              className="page-header col-12"
              style={{ marginBottom: "-1px" }}
            >
              <button
                className="btn btn-md w-100"
                style={{
                  backgroundColor: otherStatusColour,
                  fontSize: "16px",
                  color: "white",
                  pointerEvents: "none",
                  userSelect: "none",
                }}
              >
                {otherStatusName}
              </button>
            </div>
          </div>
        )}

        {/* ใช้สำหรับใบขาย แสดงสถานะประเภทจ่าย */}
        {/* {otherTypeName && otherTypeColour && (
          <div style={{ display: "flex", marginLeft: "10px" }}>
            <div
              className="page-header col-12"
              style={{ marginBottom: "-1px" }}
            >
              <button
                className="btn btn-md w-100"
                style={{
                  backgroundColor: otherTypeColour,
                  fontSize: "16px",
                  color: "white",
                  userSelect: "none",
                }}
                onClick={() => {
                  if (otherTypeName === "เงินโอน") {
                    setShowSlipModal(true);
                  }
                }}
              >
                {otherTypeName} {totalPrice > 0 ? `(${totalPrice} ฿)` : null} {otherTypeName === "เงินโอน"
                  ? <i className="fas fa-search-plus" aria-hidden="true" style={{ fontSize: "16px", color: "white" }}></i>
                  : null
                }
              </button>
            </div>
          </div>
        )} */}

        {/* ใช้สำหรับใบขาย แสดงสถานะประเภทจ่าย */}
        {otherTypeName === "จ่ายหลายช่องทาง" ? (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginLeft: "10px",
            }}
          >
            {paymentHistory.map((pay, index) => (
              <button
                key={index}
                className="btn btn-md"
                style={{
                  backgroundColor:
                    pay.Pay_Type === 1
                      ? "green"
                      : pay.Pay_Type === 2
                      ? "blue"
                      : pay.Pay_Type === 3
                      ? "purple"
                      : "gray",
                  fontSize: "16px",
                  color: "white",
                  userSelect: "none",
                }}
                onClick={() => {
                  if (pay.Pay_Type === 2) {
                    setShowSlipModal(true);
                  }
                  if (pay.Pay_Type === 3) {
                    setShowChequeModal(true);
                  }
                }}
              >
                {pay.Pay_Type === 1
                  ? "เงินสด"
                  : pay.Pay_Type === 2
                  ? "เงินโอน"
                  : pay.Pay_Type === 3
                  ? "เช็ค"
                  : "ไม่ทราบ"}{" "}
                ({formatCurrency(pay.Pay_Amount)} ฿)
              </button>
            ))}
          </div>
        ) : (
          otherTypeName &&
          otherTypeColour && (
            <div style={{ display: "flex", marginLeft: "10px" }}>
              <div
                className="page-header col-12"
                style={{ marginBottom: "-1px" }}
              >
                <button
                  className="btn btn-md w-100"
                  style={{
                    backgroundColor: otherTypeColour,
                    fontSize: "16px",
                    color: "white",
                    userSelect: "none",
                  }}
                  onClick={() => {
                    if (otherTypeName === "เงินโอน") {
                      setShowSlipModal(true);
                    }
                    if (otherTypeName === "เช็ค") {
                      setShowChequeModal(true);
                    }
                  }}
                >
                  {otherTypeName}{" "}
                  {totalPrice > 0 ? `(${formatCurrency(totalPrice)} ฿)` : null}{" "}
                  {otherTypeName === "เงินโอน" ? (
                    <i
                      className="fas fa-search-plus"
                      aria-hidden="true"
                      style={{ fontSize: "16px", color: "white" }}
                    ></i>
                  ) : null}
                </button>
              </div>
            </div>
          )
        )}

        <div style={{ marginRight: "30px" }} />

        <div
          className="d-flex align-items-center gap-2 flex-wrap"
          style={{ marginLeft: "auto", marginRight: "10px" }}
        >
          {/* ใช้สำหรับปิดงาน Vansale คืนสต็อกคลัง */}
          {window.location.pathname === "/picking-list" &&
            docStatusForClosePK === 2 && (
              // || docStatusForClosePK === 3 || docStatusForClosePK === 5
              <div style={{ marginRight: "10px" }}>
                <button
                  onClick={() => onHandleCloseForWarehouse()}
                  className="btn btn-lg"
                  style={{
                    backgroundColor:
                      docStatusForClosePK === 2 ? "red" : "#1572e8",
                    fontSize: "16px",
                    color: "white",
                  }}
                >
                  {docStatusForClosePK === 2
                    ? "ปิดงานคืนสต็อกคลัง"
                    : "ตรวจสอบคืนสต็อกคลัง"}
                </button>
              </div>
            )}

          {/* ใช้สำหรับปิดงาน Vansale บัญชี */}
          {window.location.pathname === "/picking-list" &&
            //docStatusForClosePK === 2 ||
            (docStatusForClosePK === 3 || docStatusForClosePK === 5) && (
              <div style={{ marginRight: "10px" }}>
                <button
                  onClick={() => onHandleCloseForAccount()}
                  className="btn btn-lg"
                  style={{
                    backgroundColor:
                      docStatusForClosePK === 3 ? "red" : "#1572e8",
                    fontSize: "16px",
                    color: "white",
                  }}
                >
                  {docStatusForClosePK === 3
                    ? "ปิดงานเงินบัญชี"
                    : "ตรวจสอบเงินบัญชี"}
                </button>
              </div>
            )}

          {/* ใช้สำหรับพิมพ์ รายงานขาย Vansale */}
          {window.location.pathname === "/picking-list" &&
            localStorage.getItem("company") === "2" &&
            docStatusForClosePK === 5 && (
              <div style={{ marginRight: "10px" }}>
                <button
                  onClick={() => onHandleInvoice1()}
                  className="btn btn-lg"
                  style={{
                    backgroundColor: "purple",
                    fontSize: "16px",
                    color: "white",
                  }}
                >
                  พิมพ์รายงานขาย Vansale
                </button>
              </div>
            )}

          {/* เอกสารแนบ */}
          {(window.location.pathname === "/purchase-request" ||
            window.location.pathname === "/product-receipt" ||
            window.location.pathname === "/payment-voucher") &&
            (mode === "I" || mode === "U") && (
              <>
                <button
                  hidden={isHiddenPath()}
                  onClick={() => setShowViewAttachModal(true)}
                  className="btn d-flex align-items-center justify-content-center position-relative"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    fontSize: "16px",
                    color: "white",
                    fontWeight: "bold",
                    padding: 0,
                    backgroundColor: "purple",
                  }}
                >
                  <i className="fa fa-paperclip"></i>
                  {(selectedFiles?.length > 0 ||
                    selectedRecFiles?.length > 0) && (
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {parseCurrency(selectedFiles?.length || 0) +
                        parseCurrency(selectedRecFiles?.length || 0)}
                    </span>
                  )}
                </button>
                {showViewAttachModal && (
                  <FileModal
                    mode={mode}
                    openUploadAttach={openUploadAttach}
                    setOpenUploadAttach={setOpenUploadAttach}
                    showViewAttachModal={showViewAttachModal}
                    setShowViewAttachModal={setShowViewAttachModal}
                    selectedFiles={selectedFiles}
                    selectedRecFiles={selectedRecFiles}
                    setSelectedFiles={setSelectedFiles}
                    handleRemoveImage={handleRemoveImage}
                    handleInputFileChange={handleInputFileChange}
                    handleBeforeUploadAttach={handleBeforeUploadAttach}
                  />
                )}
              </>
            )}
          {/* รายงาน */}
          {isShowStatus ? (
            <>
              {((docIsINV === "Y" &&
                window.location.pathname === "/billofsale" &&
                localStorage.getItem("company") === "2") ||
                (docIsINV === 1 && window.location.pathname === "/bill")) && (
                <button
                  onClick={() => setShowOptionInvModal(true)}
                  className="btn btn-lg"
                  style={{
                    fontSize: "16px",
                    color: "white",
                    marginRight: "10px",
                    backgroundColor: "purple",
                    fontWeight: "bold",
                  }}
                >
                  <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                  &ensp;ใบกำกับภาษี
                </button>
              )}
              <PrintInvoiceModal
                showOptionInvModal={showOptionInvModal}
                setShowOptionInvModal={setShowOptionInvModal}
                onHandleInvoice1={onHandleInvoice1}
                onHandleInvoice2={onHandleInvoice2}
                invNo={docInvNo}
              />
              {/* <button
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                onClick={() => onHandlePayslip()}
                className="btn btn-lg btn-success"
                style={{
                  fontSize: "16px",
                  color: "white",
                  marginRight: "10px",
                  fontWeight: "bold",
                }}
              >
                <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                &ensp;ใบสลิป
              </button> */}

              {window.location.pathname === "/bill" &&
                statusName === "จ่ายครบ" && (
                  <button
                    hidden={isHiddenPath()}
                    onClick={() => onHandleInvoice3()}
                    className="btn btn-lg shadow text-white"
                    style={{
                      fontSize: "16px",
                      color: "white",
                      marginRight: "10px",
                      fontWeight: "bold",
                      backgroundColor: "purple",
                    }}
                  >
                    <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                    &ensp;ใบเสร็จรับเงิน
                  </button>
                )}

              {window.location.pathname === "/billofsale" ? (
                otherTypeName === "เครดิต" ? (
                  isVatChecked ? (
                    otherStatusName === "จ่ายครบ" ? (
                      <>
                        <button
                          hidden={isHiddenPath()}
                          onClick={() => onHandleClick()}
                          className="btn btn-lg shadow text-white"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                            backgroundColor: "purple",
                          }}
                          disabled={true}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบเสร็จรับเงิน/ใบกำกับภาษี
                        </button>
                        {/* <button
                          hidden={isHiddenPath()}
                          onClick={() => onHandleClick()}
                          className="btn btn-lg btn-primary"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบส่งของ/ใบกำกับภาษี
                        </button> */}
                      </>
                    ) : (
                      // <button
                      //   hidden={isHiddenPath()}
                      //   onClick={() => onHandleClick()}
                      //   className="btn btn-lg btn-primary"
                      //   style={{
                      //     fontSize: "16px",
                      //     color: "white",
                      //     marginRight: "10px",
                      //     fontWeight: "bold",
                      //   }}
                      // >
                      //   <i
                      //     className="fa fa-print"
                      //     style={{ fontSize: "16px" }}
                      //   ></i>
                      //   &ensp;ใบส่งของ/ใบกำกับภาษี
                      // </button>
                      <></>
                    )
                  ) : otherStatusName === "จ่ายครบ" ? (
                    <>
                      <button
                        hidden={isHiddenPath()}
                        onClick={() => onHandleClick()}
                        className="btn btn-lg shadow text-white"
                        style={{
                          fontSize: "16px",
                          color: "white",
                          marginRight: "10px",
                          fontWeight: "bold",
                          backgroundColor: "purple",
                        }}
                        disabled={true}
                      >
                        <i
                          className="fa fa-print"
                          style={{ fontSize: "16px" }}
                        ></i>
                        &ensp;ใบเสร็จรับเงิน
                      </button>
                      <button
                        hidden={isHiddenPath()}
                        onClick={() => onHandleClick()}
                        className="btn btn-lg btn-primary"
                        style={{
                          fontSize: "16px",
                          color: "white",
                          marginRight: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        <i
                          className="fa fa-print"
                          style={{ fontSize: "16px" }}
                        ></i>
                        &ensp;ใบส่งของ/ใบแจ้งหนี้
                      </button>
                    </>
                  ) : (
                    <button
                      hidden={isHiddenPath()}
                      onClick={() => onHandleClick()}
                      className="btn btn-lg btn-primary"
                      style={{
                        fontSize: "16px",
                        color: "white",
                        marginRight: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      <i
                        className="fa fa-print"
                        style={{ fontSize: "16px" }}
                      ></i>
                      &ensp;ใบส่งของ/ใบแจ้งหนี้
                    </button>
                  )
                ) : isVatChecked ? (
                  <>
                    <button
                      hidden={isHiddenPath()}
                      onClick={() => onHandleInvoice3()}
                      className="btn btn-lg shadow text-white"
                      style={{
                        fontSize: "16px",
                        color: "white",
                        marginRight: "10px",
                        fontWeight: "bold",
                        backgroundColor: "purple",
                      }}
                    >
                      <i
                        className="fa fa-print"
                        style={{ fontSize: "16px" }}
                      ></i>
                      &ensp;ใบเสร็จรับเงิน
                    </button>
                    {/* <button
                      hidden={isHiddenPath()}
                      onClick={() => onHandleClick()}
                      className="btn btn-lg btn-primary"
                      style={{
                        fontSize: "16px",
                        color: "white",
                        marginRight: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      <i
                        className="fa fa-print"
                        style={{ fontSize: "16px" }}
                      ></i>
                      &ensp;ใบส่งของ/ใบกำกับภาษี
                    </button> */}
                  </>
                ) : (
                  // <button
                  //   hidden={isHiddenPath()}
                  //   onClick={() => onHandleClick()}
                  //   className="btn btn-lg btn-primary"
                  //   style={{
                  //     fontSize: "16px",
                  //     color: "white",
                  //     marginRight: "10px",
                  //     fontWeight: "bold",
                  //   }}
                  // >
                  //   <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                  //   &ensp;ใบส่งของ/ใบเสร็จรับเงิน
                  // </button>
                  <></>
                )
              ) : window.location.pathname === "/bill" ? (
                <button
                  hidden={isHiddenPath()}
                  onClick={() => onHandleClick()}
                  className="btn btn-lg btn-primary"
                  style={{
                    fontSize: "16px",
                    color: "white",
                    marginRight: "10px",
                    fontWeight: "bold",
                  }}
                >
                  <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                  &ensp;
                  {window.location.pathname === "/bill" ? "ใบวางบิล" : "รายงาน"}
                </button>
              ) : (
                <>
                  <div className="d-flex gap-2">
                    <button
                      hidden={isHiddenPath()}
                      onClick={() => onHandleClick()}
                      className="btn btn-primary d-flex align-items-center justify-content-center"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        fontSize: "16px",
                        color: "white",
                        fontWeight: "bold",
                        padding: 0,
                      }}
                    >
                      <i className="fa fa-print"></i>
                    </button>
                    <div style={{ marginRight: "18px" }} />
                  </div>
                </>
              )}
            </>
          ) : (
            <div style={{ marginRight: "15px" }} />
          )}
        </div>

        <div style={{ marginRight: "30px" }} />

        {/* Modal สำหรับแสดงสลิปเงินโอน */}
        {showSlipModal && (
          <div
            className="modal"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              zIndex: 1050,
            }}
          >
            <div className="modal-dialog modal-md" role="document">
              <div
                className="modal-content shadow-lg"
                style={{
                  borderRadius: "15px",
                  overflow: "hidden",
                  maxHeight: "auto",
                }}
              >
                <div
                  className="modal-header"
                  style={{
                    backgroundColor: "#EF6C00",
                    borderBottom: "none",
                    padding: "15px",
                  }}
                >
                  <h5 className="modal-title fw-bold text-white">ชำระเงิน</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => {
                      setShowSlipModal(false);
                      setBase64Image(null);
                    }}
                    aria-label="Close"
                  ></button>
                </div>
                <div
                  className="modal-body"
                  style={{
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  {!urlImg ||
                  (Array.isArray(urlImg) && urlImg.length === 0) ||
                  !urlImg.length ? (
                    <>
                      <h4 style={{ textAlign: "center" }}>ไม่พบรูปภาพ</h4>
                      <div className="mt-3 text-center">
                        <input
                          type="file"
                          id="fileInput"
                          style={{ display: "none" }}
                          onChange={handleUploadSlip}
                          accept=".png, .jpg, .jpeg, .gif, .svg"
                        />
                        <button
                          className="btn"
                          onClick={() =>
                            document.getElementById("fileInput").click()
                          }
                          style={{
                            borderRadius: "5px",
                            backgroundColor: "#EF6C00",
                            color: "#fff",
                            padding: "8px 16px",
                            fontSize: "14px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                            transition: "background-color 0.3s",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.backgroundColor = "#d85d00")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = "#EF6C00")
                          }
                        >
                          อัพโหลดสลิป
                        </button>
                        {base64Image && (
                          <div className="mt-3">
                            <p
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#333",
                              }}
                            >
                              รูปภาพสลิป:
                            </p>
                            <img
                              src={base64Image}
                              alt="อัพโหลดสลิป"
                              style={{
                                maxWidth: "50%",
                                border: "1px solid #ddd",
                                borderRadius: "5px",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                              }}
                            />
                            <div style={{ marginTop: "15px" }}>
                              <button
                                className="btn"
                                onClick={handleUpdateSlip}
                                style={{
                                  backgroundColor: "#4CAF50",
                                  color: "#fff",
                                  borderRadius: "5px",
                                  padding: "8px 16px",
                                  fontSize: "14px",
                                  marginRight: "10px",
                                }}
                              >
                                ยืนยัน
                              </button>
                              <button
                                className="btn"
                                onClick={() => setBase64Image(null)}
                                style={{
                                  backgroundColor: "#f44336",
                                  color: "#fff",
                                  borderRadius: "5px",
                                  padding: "8px 16px",
                                  fontSize: "14px",
                                }}
                              >
                                ยกเลิก
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <div style={{ textAlign: "center" }}>
                      {Array.isArray(urlImg) ? (
                        urlImg.map((img, index) => (
                          <img
                            key={index}
                            src={img}
                            alt={`ชำระเงิน ${index + 1}`}
                            style={{
                              width: "100%",
                              height: "auto",
                              borderRadius: "10px",
                              display: "block",
                              margin: "10px auto",
                            }}
                          />
                        ))
                      ) : (
                        <img
                          src={urlImg}
                          alt="ชำระเงิน"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "10px",
                            display: "block",
                            margin: "10px auto",
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal สำหรับแสดงเช็ค */}
        {showChequeModal && (
          <div
            className="modal"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1050,
            }}
          >
            <div className="modal-dialog modal-md" role="document">
              <div
                className="modal-content shadow-lg"
                style={{ borderRadius: "15px", overflow: "hidden" }}
              >
                <div
                  className="modal-header"
                  style={{
                    backgroundColor: "#EF6C00",
                    borderBottom: "none",
                    padding: "20px",
                  }}
                >
                  <h5 className="modal-title fw-bold text-white">เช็ค</h5>
                </div>
                <div className="modal-body">
                  <div
                    class="p-3 rounded mt-4"
                    style={{ backgroundColor: "#DCDCDC" }}
                  >
                    <h6 class="fw-bold mb-3">รายละเอียดเช็ค</h6>
                    <div class="row g-3">
                      <div class="col-12">
                        <label class="form-label fw-bold">เลขที่เช็ค</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="กรอกเลขที่เช็ค"
                          value={chequeNo}
                          disabled={true}
                        />
                      </div>
                      <div class="col-12">
                        <label class="form-label fw-bold">
                          ชื่อธนาคาร/สาขา
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="กรอกชื่อธนาคาร/สาขา"
                          value={chequeName}
                          disabled={true}
                        />
                      </div>
                      <div class="col-12">
                        <label class="form-label fw-bold">ลงวันที่</label>
                        <Datetime
                          className="input-spacing-input-date"
                          name="whDocDate"
                          value={chequeBranch}
                          onChange={(date) =>
                            handleChangeDateMaster(date, "docDate")
                          }
                          dateFormat="DD-MM-YYYY"
                          timeFormat={false}
                          inputProps={{
                            // readOnly: true,
                            disabled: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer" style={{ borderTop: "none" }}>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ borderRadius: "5px" }}
                    onClick={() => setShowChequeModal(false)}
                  >
                    ปิด
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default Breadcrumbs;
